//import {fullObject,fullObjectChanged} from './testdata';
import {detailedDiff} from "deep-object-diff";

var lookups = ['region','regionType','role','posterSize','ourContact','distributor','clientType','clientSubType','salesTeams','salesTeam','clientCompany','clientCompanyContact','sundryType','experientialType','ambientType'];

function graphqlSetLookups(newLookups) {
  lookups = newLookups;
}

function isLookup(name) {
  return lookups.indexOf(name)>-1;
}


const graphqlFindResults = (obj) => {
  // in a simple query, the results are identified by the name
  // of the object and sometimes a data (when paginated)
  // this just finds an array
  try {
    while(obj && !Array.isArray(obj)) {
      var keys = Object.keys(obj);
      var k = (keys[0]=='__typename')?keys[1]:keys[0];
      obj = obj[k];
    }
  }  catch(e) {
    return false;
  }
  return obj;
}


// as before, finds the results but leaves the last object
// e.g.  a.b[myresults] returns {value:b[myresults],key:b}
const graphqlFindResultsWrapped = (srcObj) => {
  var obj = srcObj;
  var i = 0;
  try {
    while(obj && !Array.isArray(obj) && i<100) {
      var keys = Object.keys(obj);
      var k = (keys[0]=='__typename')?keys[1]:keys[0];
      if(Array.isArray(obj[k])) {
        return {response:obj,key:k};
      }
      i++;
      obj = obj[k];
      if(i>=100) {
        console.log('more than 100 calls made o_O');
      }
    }
  }  catch(e) {
    return false;
  }
  return false;
}



/*
these functions convert from standard JS objects to something suitable for Input types created by lighthouse
Basically:
a {
  id
  b {
    id
    name
  }
}

Becomes:
a {
  id
  b {
   create: {
     id name ...
    }
  }
}

When 'b' is in the lookup array at the top of the file, it is no longer updated/deleted/created, but instead it is simply connected/disconnected from the parent record.
a {
  id
  b {
    connect: id
  }
}

This should also work for arrays of children.
 */

/* create an array of children when the parent has been created */
function newArray(arrayToCopy,saveId) {
  // only creates...
  var retVal = {create:[]};
  arrayToCopy.forEach((val)=> {
    retVal.create.push(newObject(val,saveId));
  });
  return retVal;
}

/* create a copy of an object suitable for a 'create:' action */
function newObject(objectToCopy,savedId) {
  var retVal = {};
  console.log('newObject',objectToCopy,savedId);
  if(objectToCopy instanceof File) {
      return objectToCopy; // may or may not be safe /shrug
  }
  Object.entries(objectToCopy).forEach(([k,v]) => {
    if(k==='__typename'||(!savedId && k==='id')) return;
    if(v!=null && typeof v === 'object') {
      if(isLookup(k)) {
        if (Array.isArray(v)) {
          var data = newArray(v,true);
          retVal[k] = {};
          if(data.create) {
            retVal[k].connect = data.create.map((val) => {
              return val.id;
            });
          }
        } else {
          if(v.id) {
            retVal[k] = {connect:v.id};
          }
        }
      } else {
        if (Array.isArray(v)) {
          retVal[k] = newArray(v,false);
        } else {
          if(k==='campaignComponent') {
            // special case...
            retVal['qty'] = parseInt(v.qty);
            if(v.region) {
              retVal['region_id'] = v.region ? v.region.id : null;
            }
            if(v.regionType) {
              retVal['region_type_id'] = v.regionType ? v.regionType.id : null;
            }
            if(v.unit_value_local) {
              retVal['unit_value_local'] = v.unit_value_local ? v.unit_value_local : 0;
            }
            if(v.price_divisor) {
              retVal.price_divisor = v.price_divisor ? v.price_divisor : 0;
            }
            if(v.currency) {
              retVal.currency_id = v.currency?.id;
            }
          } else {
            console.log('handling',k,v);
            if(isLookup(k)) {
              console.log('do something with',v);
            } else {
              retVal[k] = newObject(v, false);
            }
          }
        }
      }
    } else {
      if(!isLookup(k)) {
        retVal[k] = v;
      }
    }
  });
  return retVal;
}


/* compare an array of objects */
export function diffArray(src,changed,withIds=false) {
  console.log('diffarray',src,changed);
  var srcObject = {}, changedObject = {};
  if(src) {
    src.forEach((v) => {
      srcObject[v.id] = v;
    });
  }
  if(changed) {
    changed.forEach((v) => {
      changedObject[v.id] = v;
    });
  }
  var diff = detailedDiff(srcObject,changedObject);
  var retVal = {delete:[],update:[],create:[]};
  var toInspect = [];
  Object.entries(diff.added).forEach(([k,v])=>{
    //console.log('diffArray',v);
    if(!v.id) {
      // child was added, change to update parent...
      //console.log('update parent?',k,v);
      console.log('diffArray','NO ID, inspecting this deeper...',k,v);
      toInspect.push(k);
    } else {
      console.log('diffArray','has ID, assuming olde');
      var nV = newObject(v);
      if(withIds) { nV.id = v.id; }
      console.log('v is',v,'nv is',nV);
      retVal.create.push(nV);
    }
  });
  Object.entries(diff.deleted).forEach(([k,v])=> {
    if(v) {
      // child was deleted, change to update parent...
      toInspect.push(k);
    } else {
      retVal.delete.push(k);
    }
  });
  Object.entries(diff.updated).forEach(([k])=> {
    toInspect.push(k);
  });
  toInspect = [...new Set(toInspect)];
  toInspect.forEach((id)=> {
    var result = diffObject(srcObject[id],changedObject[id]);
    console.log('diffing',srcObject[id],'to',changedObject[id]);
    console.log('diffed to',result);
    //result.id = id; // add the ID for updates (obviously)
    if(result) {
      retVal.update.push(result);
    }
    console.log('result of object diff',id,srcObject,changedObject,srcObject[id],changedObject[id],id,result);
  });
  return retVal;
}

/* compare an object */
function diffObject(src,changed,isBase=0) {
  //console.log('diffObject',src,changed);
  var retVal = {};
  var keys = [];
  if(src) {
    keys = Object.keys(src);
  }
  if(changed) {
    keys.push(...Object.keys(changed));
  }
  keys = [...new Set(keys)];
  keys.forEach((k)=> {
    console.log('compare',k);
    if(k==='__typename' || k==='trashed') return;
    var v = src?src[k]:null;
    var newValue = changed?changed[k]:null;
    var compareObject = v!=null?v:newValue;
    if(compareObject!=null && typeof compareObject==='object') {
      console.log('outer compare',k,isLookup(k));
      if(isLookup(k)) {
        console.log('isLookup',Array.isArray(compareObject));
        if (Array.isArray(compareObject)) {
          var diffs = diffArray(v, newValue,true);
          console.log('innerobject diff',diffs);
          // deletes are disconnected
          // updates are connected
          // creates are connected
          // duplicates are assumed to be safe
          var connects = [],disconnects=[];
          diffs.create.forEach((v)=> {
            connects.push(v.id);
          });
          diffs.update.forEach((v)=> {
            connects.push(v.id);
          });
          diffs.delete.forEach((v) => {
            disconnects.push(v);
          });
          retVal[k] = {
            connect: connects,
            disconnect:disconnects
          };
          console.log('retval is',retVal[k]);
        } else {
          if(newValue!=null) {
            if(newValue.id && (!v || newValue.id!=v.id)) {
              retVal[k] = {connect: newValue.id};
            }
          } else {
            retVal[k] = {disconnect: true};
          }
        }

      } else {
        if (Array.isArray(compareObject)) {
          console.log('do DiffArray',k,v,newValue);
          retVal[k] = diffArray(v, newValue);
        } else {
            if(newValue instanceof File) {
                retVal[k] = newValue;
            } else {
                var object = diffObject(v, newValue);
                if (object) {
                    retVal[k] = {update: object};
                } else {
                    // the objects are identical, so record nothing
                    // TODO: work out why this was delete
                    //  retVal[k] = {delete:object};
                }
            }
        }
      }
    } else {
      if(v!=newValue ||isBase) {
        retVal[k] = newValue;
      }
    }
  });
  if(!Object.entries(retVal).length) {
    return null;
  }
  if(src && src.id) {
    retVal.id = src.id;
  }
  return retVal;
}

function graphqlTidy(val) {
  if(!val) return val;
  Object.entries(val).forEach(([k,v])=> {
    if(v===null) {
      delete val[k];
    }
  });
  console.log('tidied',val);
  return val;
}

function graphqlObjectToInput(src,changed) {
  return diffObject(src,changed,true);
}

function convertFieldsToGraphqlVariables(qs) {
  // takes an array of FIELDS and turns them into variables
  var params = {};
  if(!qs || !qs.length) {
    return params;
  }
  qs.forEach((field) => {
    console.log('convert', field);
    switch (field['type']) {
      case 'like':
        params[field.name + '_like'] = '%' + field.value + '%';
        break;
      case 'prefix':
      case 'starts':
        params[field.name + '_like'] = field.value + '%';
        break;
      case 'ends':
        params[field.name + '_like'] = '%' + field.value;
        break;
      case 'between':
      case 'range':
        // usually separated by a hyphen
        var p = field.value.split('-');
        // if it's a date, then there are many hypens, so separate by _ instead
        if (p.length > 2) { p = field.value.split('_'); }
        params[field.name+'_between'] = {from:p[0],to:p[1]};
//        params[field.name + '_from'] = p[0];
        //params[field.name + '_to'] = p[1];
        break;

      // composite objects are represented by name,value-name,value
      // e.g. {a:valA,b:valB} =>  a-valA,b-valB
      case 'c':
        p = field.value.split(',');
        p.forEach((v) => {
          var vp = v.split('-',2);
          params[field.name+'_'+vp[0]] = vp[1];
        });
      break;
      case 'not':
        var value = field.value.split(',');
        console.log('not from',value);
        value = value.map((v)=>v.replace('%%',','));
        console.log('not to',value);
        params[field.name + '_' + field.type] = value;
      break;
      case 'in':
      case 'group':
        var value = field.value.split(',');
        console.log('in from',value);
        value = value.map((v)=>v.replace('%%',','));
        console.log('in to',value);
        params[field.name + '_' + field.type] = value;
      break;
      default:
        params[field.name + '_' + field.type] = field.value;
      break;
    }
  });
  console.log('converted into', params);
  return params;
}



export {convertFieldsToGraphqlVariables,graphqlObjectToInput,diffArray as graphqlArrayToInput,graphqlTidy,graphqlSetLookups,graphqlFindResults,graphqlFindResultsWrapped};
